<app-top-menu></app-top-menu>

<div class="justify-content-center">
  <div class="row justify-content-center content-row" style="background: #F8F8FF">
    <div class="form-col">
      <div class="input-container">
        <form
          [formGroup]="companyForm"
          (ngSubmit)="submit()"
          class="row g-3 m-0"
        >
          <!-- Phone Number -->
          <div class="col-md-6 tax-input-group">
            <label>Phone Number *</label>
            <input
              class="tax-form-control"
              formControlName="phoneNumber"
              type="tel"
            />
            <app-error-message
              controlName="phoneNumber"
              label="Phone Number"
              [form]="companyForm"
            ></app-error-message>
          </div>

          <!-- Email -->
          <div class="col-md-6 tax-input-group">
            <label>Email *</label>
            <input
              class="tax-form-control"
              formControlName="email"
              type="email"
            />
            <app-error-message
              controlName="email"
              label="Email"
              [form]="companyForm"
            ></app-error-message>
          </div>

          <!-- Company Name -->
          <div class="col-md-6 tax-input-group">
            <label>Company Name</label>
            <input
              class="tax-form-control"
              formControlName="companyName"
            />
          </div>

          <!-- Company Address -->
          <div class="col-md-6 tax-input-group">
            <label>Company Address</label>
            <input
              class="tax-form-control"
              formControlName="companyAddress"
            />
          </div>

          <button
            type="submit"
            [disabled]="companyForm.invalid"
            style="
              background: #cc9e0a;
              color: #fff;
              font-weight: 600;
              height: 45px;
              margin-top: 30px;
            "
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
